(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmuhub-find-your-cartridges"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pmuhub-cartridge-finder')) {
  customElements.define('pmuhub-cartridge-finder', class extends HTMLElement {
    connectedCallback() {
      this.syncControls(true);
      this.submitHandler = (event) => {
        if (!event.target.matches('.pmuhub-finder__form')) return;
        event.preventDefault();
        if (this.choicesPending) return;
        const target = new URL(window.location.href);
        target.searchParams.delete('page');
        target.searchParams.delete('section_id');
        this.querySelectorAll('select[name]').forEach((select) => {
          if (select.selectedOptions[0]?.hasAttribute('data-keep-multiple')) return;
          target.searchParams.delete(select.name);
          if (select.value) target.searchParams.set(select.name, select.value);
        });
        const available = this.querySelector('.pmuhub-finder__availability input');
        if (available) {
          const retainedAvailability = this.preserveSidebarAvailability && !available.checked ? target.searchParams.getAll('filter.v.availability') : [];
          target.searchParams.delete('filter.v.availability');
          target.searchParams.delete('finder_availability');
          if (available.checked) target.searchParams.set('filter.v.availability', '1');
          else if (retainedAvailability.length) retainedAvailability.forEach(value => target.searchParams.append('filter.v.availability', value));
          else target.searchParams.set('finder_availability', 'all');
        }
        target.hash = this.id;
        this.rememberAction("finder", target);
        window.location.assign(target.href);
      };
      this.refreshHandler = () => this.refresh();
      this.addEventListener('submit', this.submitHandler);
      document.addEventListener('on:facet-filters:updated', this.refreshHandler);
      this.choiceHandler = (event) => {
        if (event.target.matches('.pmuhub-finder__checkbox')) this.preserveSidebarAvailability = false;
      };
      this.addEventListener('change', this.choiceHandler);
      this.historyHandler = () => this.refresh();
      this.pageshowHandler = (event) => { if (event.persisted) this.refresh(); };
      window.addEventListener('popstate', this.historyHandler);
      window.addEventListener('pageshow', this.pageshowHandler);
      this.setupAnalytics();
      this.updateChoices(0);
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.submitHandler);
      window.removeEventListener('popstate', this.historyHandler);
      window.removeEventListener('pageshow', this.pageshowHandler);
      document.removeEventListener('on:facet-filters:updated', this.refreshHandler);
      this.choiceController?.abort();
      this.removeEventListener('change', this.choiceHandler);
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.viewTimer);
      clearInterval(this.analyticsTimer);
      document.removeEventListener('change', this.analyticsChange, true);
      document.removeEventListener('click', this.analyticsClick, true);
      document.removeEventListener('visitorConsentCollected', this.analyticsConsent);
    }
    syncControls(initialLoad = false) {
      const url = new URL(window.location.href);
      this.querySelectorAll('select[name]').forEach((select) => {
        const values = url.searchParams.getAll(select.name).flatMap(value => value.split(','));
        if (!values.length) return;
        const value = values.join(',');
        let option = [...select.options].find(option => option.value === value);
        if (!option) {
          option = new Option(values.join(', '), value);
          if (values.length > 1) option.setAttribute('data-keep-multiple', '');
          select.add(option);
        }
        select.value = value;
      });
      this.appliedConfiguration = this.querySelector('select[name="filter.v.option.needle configuration"]')?.selectedOptions[0]?.textContent.trim() || 'any';
      if (!url.searchParams.has('filter.v.option.needle configuration')) this.appliedConfiguration = 'any';
      const values = url.searchParams.getAll('filter.v.availability').flatMap(value => value.split(','));
      this.preserveSidebarAvailability = values.length > 0;
      const checkbox = this.querySelector('.pmuhub-finder__availability input');
      const pristine = ![...url.searchParams.keys()].some(key => key.startsWith('filter.')) && url.searchParams.get('finder_availability') !== 'all';
      if (checkbox) checkbox.checked = values.length ? values.length === 1 && values[0] === '1' : pristine && this.dataset.defaultAvailable === 'true';
    }
    async updateChoices() {
      this.choiceController?.abort();
      const controller = new AbortController();
      this.choiceController = controller;
      let selects = [...this.querySelectorAll('select[name]')];
      const button = this.querySelector('button[type="submit"]');
      const status = this.querySelector('.pmuhub-finder__status');
      this.choicesPending = true;
      selects.forEach(select => { select.disabled = true; });
      if (button) button.disabled = true;
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        if (!this.fullChoices) {
          if (status) status.textContent = this.dataset.loadingLabel;
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, {signal: controller.signal});
          if (!response.ok) throw new Error('Unable to load choices');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const sources = [...doc.querySelectorAll('pmuhub-cartridge-finder select[name]')];
          if (sources.length !== 3 || !selects.every(select => sources.some(source => source.name === select.name))) throw new Error('Missing choices');
          this.fullChoices = sources;
        }
        if (controller.signal.aborted || this.choiceController !== controller) return;
        this.fullChoices.forEach(source => {
          let select = this.querySelector('select[name="' + source.name + '"]');
          if (!select) {
            const field = source.closest('.pmuhub-finder__field').cloneNode(true);
            this.querySelector('.pmuhub-finder__form').insertBefore(field, this.querySelector('.pmuhub-finder__availability'));
            select = field.querySelector('select');
            select.value = new URL(window.location.href).searchParams.getAll(select.name).join(',');
          }
          this.querySelector('.pmuhub-finder__form').insertBefore(select.closest('.pmuhub-finder__field'), this.querySelector('.pmuhub-finder__availability'));
        });
        selects = [...this.querySelectorAll('select[name]')];
        selects.forEach(select => {
          const previous = select.value;
          const selected = select.selectedOptions[0]?.cloneNode(true);
          const source = this.fullChoices.find(field => field.name === select.name);
          select.replaceChildren(...[...source.options].filter(option => !option.hasAttribute('data-keep-multiple')).map(option => option.cloneNode(true)));
          if (previous && ![...select.options].some(option => option.value === previous) && selected) select.add(selected);
          select.value = previous;
        });
        if (status) status.textContent = '';
      } catch (_) {
        if (this.choiceController === controller && status) status.textContent = this.dataset.failureLabel;
      } finally {
        clearTimeout(timer);
        if (this.choiceController === controller) {
          this.choicesPending = false;
          selects.forEach(select => { select.disabled = false; });
          if (button) button.disabled = false;
        }
      }
    }
    analyticsAllowed() {
      try {
        return this.dataset.analyticsEnabled === 'true' && !window.Shopify?.designMode &&
          window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
      } catch (_) { return false; }
    }
    filterState(url = new URL(window.location.href)) {
      const read = (key) => url.searchParams.getAll(key).join('|').slice(0, 100) || 'any';
      return {
        needle_count: read('filter.v.option.needle count'),
        needle_diameter: read('filter.v.option.needle diameter'),
        availability_filter: read('filter.v.availability'),
        filter_brand: read('filter.p.vendor'),
        filter_configuration: (this.appliedConfiguration || 'any').slice(0, 100)
      };
    }
    filterSignature(url = new URL(window.location.href)) {
      return JSON.stringify([...url.searchParams.entries()].filter(([key]) => key.startsWith('filter.')).sort());
    }
    track(name, extra = {}) {
      if (!this.analyticsAllowed() || typeof window.gtag !== 'function' || !/^G-[A-Z0-9]+$/.test(this.dataset.measurementId || '')) return false;
      const count = Number(this.dataset.resultsCount || 0);
      const params = Object.assign({
        send_to: this.dataset.measurementId,
        collection_handle: 'pmu-cartridges',
        result_count: count,
        result_status: count === 0 ? 'no_results' : 'has_results',
        transport_type: 'beacon'
      }, this.filterState(), extra);
      if (new URL(window.location.href).searchParams.get('finder_debug') === '1') params.debug_mode = true;
      window.gtag('event', name, params);
      return true;
    }
    rememberAction(source, target) {
      if (!this.analyticsAllowed()) return;
      try {
        sessionStorage.setItem('pmuhub_finder_pending', JSON.stringify({
          source, before: this.filterSignature(), target: target ? this.filterSignature(target) : null,
          path: window.location.pathname, time: Date.now()
        }));
      } catch (_) {}
    }
    consumeAction() {
      if (!this.analyticsAllowed() || typeof window.gtag !== 'function') return;
      try {
        const pending = JSON.parse(sessionStorage.getItem('pmuhub_finder_pending') || 'null');
        if (!pending) return;
        const current = this.filterSignature();
        if (Date.now() - pending.time > 120000 || pending.path !== window.location.pathname) {
          sessionStorage.removeItem('pmuhub_finder_pending');
          return;
        }
        if (pending.target !== null && pending.target !== current) return;
        if (pending.target === null && pending.before === current) return;
        sessionStorage.removeItem('pmuhub_finder_pending');
        if (this.track('cartridge_filter_apply', {filter_source: pending.source})) this.lastFilterSource = pending.source;
      } catch (_) {}
    }
    maybeTrackView() {
      if (this.inView && !this.viewTracked && document.visibilityState === 'visible') {
        this.viewTracked = this.track('cartridge_finder_view', {filter_source: 'finder'});
      }
    }
    setupAnalytics() {
      if (this.dataset.analyticsEnabled !== 'true' || window.Shopify?.designMode) return;
      this.analyticsChange = (event) => {
        if (event.target.closest('#facet-filters') && event.target.name?.startsWith('filter.')) this.rememberAction('sidebar');
      };
      this.analyticsClick = (event) => {
        const link = event.target.closest('a[href]');
        if (!link || event.button !== 0) return;
        const inFinder = this.contains(link);
        const inSidebar = link.closest('#facet-filters');
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if ((inFinder || inSidebar) && url.pathname === window.location.pathname && this.filterSignature(url) !== this.filterSignature()) {
          this.rememberAction(inFinder ? 'finder' : 'sidebar', url);
        } else if (link.closest('[id$="__collection-products"]') && url.pathname.includes('/products/') && this.filterSignature() !== '[]') {
          this.track('cartridge_product_click', {
            filter_source: this.lastFilterSource || 'filtered_collection',
            product_handle: url.pathname.split('/products/')[1].slice(0, 100)
          });
        }
      };
      this.analyticsConsent = () => {
        if (this.analyticsAllowed()) { this.consumeAction(); this.maybeTrackView(); }
        else { try { sessionStorage.removeItem('pmuhub_finder_pending'); } catch (_) {} }
      };
      document.addEventListener('change', this.analyticsChange, true);
      document.addEventListener('click', this.analyticsClick, true);
      document.addEventListener('visitorConsentCollected', this.analyticsConsent);
      this.observer = new IntersectionObserver((entries) => {
        clearTimeout(this.viewTimer);
        this.inView = entries.some((entry) => entry.isIntersecting);
        if (this.inView) this.viewTimer = setTimeout(() => this.maybeTrackView(), 1000);
      }, {threshold: 0.5});
      this.observer.observe(this);
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => this.analyticsConsent());
      }
      this.consumeAction();
      let attempts = 0;
      this.analyticsTimer = setInterval(() => {
        this.consumeAction();
        this.maybeTrackView();
        if (++attempts >= 20) clearInterval(this.analyticsTimer);
      }, 500);
    }
    async refresh() {
      this.choiceController?.abort();
      this.controller?.abort();
      const controller = new AbortController();
      this.controller = controller;
      this.setAttribute('aria-busy', 'true');
      const button = this.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.hash = '';
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Unable to refresh filters');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = doc.querySelector('pmuhub-cartridge-finder');
        if (!updated) throw new Error('Missing filter section');
        if (!controller.signal.aborted) {
          this.innerHTML = updated.innerHTML;
          this.dataset.resultsCount = updated.dataset.resultsCount;
          this.syncControls();
          this.consumeAction();
          this.updateChoices(0);
        }
      } catch (error) {
        if (error.name !== 'AbortError') window.location.reload();
      } finally {
        if (this.controller === controller) {
          this.removeAttribute('aria-busy');
          const submit = this.querySelector('button[type="submit"]');
          if (submit) submit.disabled = Boolean(this.choicesPending);
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pmuhub-review-compare"] && !Shopify.designMode) return;
  try {
    
function syncPmuReviewTotals(root) {
const count=root.querySelector('.jdgm-carousel-number-of-reviews[data-number-of-reviews]');
const score=root.querySelector('.jdgm-all-reviews-rating[data-score]');
if(count&&score){root.querySelector('[data-pmu-count]').textContent=Number(count.dataset.numberOfReviews).toLocaleString()+' reviews';root.querySelector('[data-pmu-score]').textContent=score.dataset.score+'/5';}
}
function initPmuReviewComparisons(){
document.querySelectorAll('.pmu-review-compare').forEach(root=>{
if(root.dataset.pmuInitialized)return;
root.dataset.pmuInitialized='true';
syncPmuReviewTotals(root);
const grid=root.querySelector('.pmu-review-grid');
const cards=Array.from(grid.querySelectorAll('.pmu-review-card'));
const prev=root.querySelector('[data-pmu-prev]');
const next=root.querySelector('[data-pmu-next]');
const position=root.querySelector('[data-pmu-position]');
let desktopPage=0;
function mobile(){return window.matchMedia('(max-width: 749px)').matches;}
function index(){const step=cards[1].offsetLeft-cards[0].offsetLeft;return Math.max(0,Math.min(cards.length-1,Math.round(grid.scrollLeft/step)));}
function update(){if(mobile()){const n=index();position.textContent=(n+1)+' / '+cards.length;prev.disabled=n===0;next.disabled=n===cards.length-1;}else{const first=desktopPage*6;position.textContent=(first+1)+'–'+Math.min(first+6,cards.length)+' / '+cards.length;prev.disabled=desktopPage===0;next.disabled=first+6>=cards.length;}}
function move(delta){if(mobile()){const target=cards[Math.max(0,Math.min(cards.length-1,index()+delta))];grid.scrollTo({left:target.offsetLeft-cards[0].offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}else{desktopPage=Math.max(0,Math.min(Math.ceil(cards.length/6)-1,desktopPage+delta));root.dataset.pmuPage=String(desktopPage);update();}}
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));grid.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();
new MutationObserver(()=>syncPmuReviewTotals(root)).observe(root.querySelector('.pmu-review-original'),{subtree:true,childList:true,attributes:true,attributeFilter:['data-number-of-reviews','data-score']});
});
}
initPmuReviewComparisons();
document.addEventListener('shopify:section:load',initPmuReviewComparisons);

  } catch(e) { console.error(e); }
})();
})();
